'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var clearSelection = function (element) {
    const $element = $(element);
    const $lastLevel = $element.closest('.dropdown.show').children('.dropdown-menu').find('.dropdown-menu[aria-hidden="false"]');
    const $openBottomMenu = $element.closest('.experience-component.show');
    const $openDropdown = $openBottomMenu.length ? $openBottomMenu : $element.closest('.dropdown.show');

    $openDropdown.children('.nav-link').attr('aria-expanded', 'false');
    if ($lastLevel.length) {
        $lastLevel.attr('aria-hidden', 'true');
        if ($openBottomMenu.length) {
            $openBottomMenu.removeClass('show');
        } else {
            $lastLevel.parents('.inline-menu-item.show').removeClass('show');
        }
        $lastLevel.children('.top-category').detach();
    } else {
        $openDropdown.children('.dropdown-menu').attr('aria-hidden', 'true');
        $openDropdown.removeClass('show');
        $element.closest('.dropdown').children('.dropdown-menu').children('.top-category').detach();
    }
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $element.closest('li').detach();
};

module.exports = function () {
    const headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    const $headerBanner = $('.header-banner');

    $('.header-banner .close').on('click', function () {
        $headerBanner.addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $headerBanner.removeClass('d-none');
    }

    keyboardAccessibility(
        '.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) {
                // down
                if (menuItem.hasClass('nav-item')) {
                    // top level
                    $('.navbar-nav .show').removeClass('show').children('.dropdown-menu').removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a').first().focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    // if this is the last menuItem
                    if (!(menuItem.next().length > 0)) {
                        // set focus to the first menuitem
                        menuItem.parent().parent().find('li > a').first().focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            // right
            39: function (menuItem) {
                // top level
                if (menuItem.hasClass('nav-item')) {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a').first().focus();
                }
            },
            // up
            38: function (menuItem) {
                // top level
                if (menuItem.hasClass('nav-item')) {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) {
                    // first menuItem
                    menuItem.parent().parent().removeClass('show').children('.nav-link').attr('aria-expanded', 'false');
                    // set the focus to the last menuItem
                    menuItem.parent().children().last().children().first().focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) {
                // left
                if (menuItem.hasClass('nav-item')) {
                    // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show').closest('li.show').removeClass('show').children().first().focus().attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) {
                // escape
                var parentMenu = menuItem.hasClass('show') ? menuItem : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link').attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            },
        },
        function () {
            return $(this).parent();
        }
    );

    $(document).on('click', '.dropdown:not(.disabled) [data-toggle="dropdown"]', function (e, closeAll = false) {
        const $this = $(this);
        const $slickCarousel = $this.parent().find('.carousel-wrapper');
        let $openTabs = $this.parent().siblings('.show');
        const isTopLevel = $this.hasClass('top-level');
        const $dropdownMenu = $this.next('.dropdown-menu').length ? $this.next('.dropdown-menu') : $this.next().children('.dropdown-menu');

        if ($this.parents('.bottom-links-wrapper').length) {
            $openTabs = $this.parents('.bottom-links-wrapper').siblings('.show');
        } else {
            $openTabs = $openTabs.length ? $openTabs : $this.parent().siblings('.bottom-links-wrapper').find('.dropdown-menu.show');
        }

        if (!$dropdownMenu.length) {
            return;
        }

        if (isTopLevel) {
            if ($openTabs.length && !app.isDesktop()) {
                $openTabs.find('.dropdown.show .close-menu, .experience-component.show .close-menu').each(function () {
                    clearSelection(this);
                });
                clearSelection($openTabs.find('.close-menu')[0]);
            }

            const $bottomLinks = $('.bottom-links-wrapper:first').clone();

            if (!$dropdownMenu.find('.bottom-links-wrapper').length) {
                $dropdownMenu.append($bottomLinks);
            }
        }

        if (!app.isDesktop()) {
            const li = $('<li class="top-category"></li>');
            const link = $('<span class="overlay-title"></span>').html($this.text());
            const closeMenu = $('<li class="nav-menu"></li>');
            const closeMenuClone = $('.close-menu').first().clone();
            $dropdownMenu.css('top', '');

            li.append(link);
            closeMenuClone.find('.close-button').detach();
            closeMenu.append(closeMenuClone);
            if (isTopLevel) {
                li.addClass('d-none');
                closeMenu.addClass('d-none');
            }
            $dropdownMenu.prepend(li).prepend(closeMenu).attr('aria-hidden', 'false');
            if ($openTabs.length) {
                $openTabs.find('.dropdown.show .close-menu, .experience-component.show .close-menu').each(function () {
                    clearSelection(this);
                });
                clearSelection($openTabs.find('.close-menu')[0]);
            }
            // copy navigation menu into view
            $this.parent().addClass('show');
            $this.attr('aria-expanded', 'true');
            $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
            e.preventDefault();
            $slickCarousel.trigger('initSlick');
            $('.experience-header').removeClass('hide-header');
            $dropdownMenu.find('.bottom-links-wrapper').toggleClass('mt-auto', $dropdownMenu.get(0).scrollHeight === $dropdownMenu.height());
        } else {
            const hasDropdown = $dropdownMenu.length;
            const $openTopLevel = $this.parent().siblings('.show');
            $dropdownMenu.css('top', $('.header-wrapper').height());

            if (!$this.parent().hasClass('show') && hasDropdown) {
                e.preventDefault();
                if ($openTopLevel.length) {
                    $openTopLevel.find('.top-level').trigger('click', true);
                }
                $('.experience-header').removeClass('hide-header');
                $('body').toggleClass('no-scroll', true);
                $('nav').toggleClass('menu-active', true);
                var eventElement = this;

                if ($slickCarousel.hasClass('slick-initialized')) {
                    $slickCarousel.slick('unslick');
                }
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        const $liThis = $(this);

                        $liThis.find('.show').each(function () {
                            clearSelection(this);
                        });
                        if ($liThis.hasClass('show')) {
                            $liThis.removeClass('show');
                            $liThis.children('ul.dropdown-menu').removeClass('show');
                            $liThis.children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $this.parent().addClass('show');
                $dropdownMenu.addClass('show');
                if (!$this.hasClass('top-level')) {
                    $dropdownMenu.find('.dropdown-toggle').trigger('click');
                    $this.attr('aria-expanded', 'true');
                } else {
                    setTimeout(() => {
                        $dropdownMenu.css('bottom', $dropdownMenu.find('.bottom-links-wrapper').outerHeight());
                    }, 300);
                }
                let $openSiblings = $this.parent().siblings('.show');

                if ($this.parents('.bottom-links-wrapper').length) {
                    $openSiblings = $this.parents('.bottom-links-wrapper').siblings('.show');
                } else {
                    $openSiblings = $openSiblings.length ? $openSiblings : $this.parent().siblings('.bottom-links-wrapper').find('.dropdown-menu.show').parent();
                }
                if ($openSiblings.length) {
                    $openSiblings.removeClass('show');
                    $openSiblings.children('.dropdown-menu').removeClass('show');
                    $openSiblings.children('.nav-link').attr('aria-expanded', 'false');
                }
            } else if ($this.hasClass('top-level')) {
                const $openLevel = $dropdownMenu.find('.dropdown.show, .bottom-links-wrapper .experience-component.show');
                e.preventDefault();

                if (!$openLevel.length || closeAll) {
                    $dropdownMenu.css('bottom', 0);
                    $dropdownMenu.removeClass('show');
                    $this.parent().removeClass('show');
                    $('body').toggleClass('no-scroll', false);
                    $('nav').toggleClass('menu-active', false);
                    $this.parent().children('.nav-link').attr('aria-expanded', 'false');
                }

                if ($openLevel.length) {
                    $openLevel.removeClass('show');
                    $openLevel.children('.dropdown-menu').removeClass('show');
                    $openLevel.children('.nav-link').attr('aria-expanded', 'false');
                    const $lastLevelOpenItems = $openLevel.find('.inline-menu-item.show');

                    if ($lastLevelOpenItems.length) {
                        $lastLevelOpenItems.removeClass('show');
                        $lastLevelOpenItems.children('.dropdown-menu').removeClass('show');
                        $lastLevelOpenItems.children('.nav-link').attr('aria-expanded', 'false');
                    }
                }
            }
        }
    });

    $('.menu-background-overlay').on('click', function () {
        $('.dropdown.show .top-level').trigger('click', true);
    });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        const $mainMenu = $('.main-menu');

        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();
        $('body').removeClass('no-scroll');
        $('nav').removeClass('menu-active');
        $('.navbar-toggler').focus();
        $mainMenu.attr('aria-hidden', 'true');
        $mainMenu.siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        const $navbarNav = $('.navbar-nav');

        $navbarNav.find('.top-category').detach();
        $navbarNav.find('.nav-menu').detach();
        $navbarNav.find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        const $mainMenu = $('.main-menu');

        $('.experience-header').removeClass('hide-header');
        $mainMenu.toggleClass('in');
        $('body').addClass('no-scroll');
        $('nav').addClass('menu-active');
        $('.modal-background').show();

        $mainMenu.removeClass('d-none');
        $mainMenu.attr('aria-hidden', 'false');
        $mainMenu.siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
        $('.dropdown:not(.disabled) .top-level:first').trigger('click');
    });

    keyboardAccessibility(
        '.navbar-header .user',
        {
            40: function ($popover) {
                // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) {
                // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () {
                // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () {
                // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });
    $('body').on('click', '#myaccount', function (event) {
        event.preventDefault();
    });
};
